import { RegistrationExpiryRow } from "./types";

export const transformRegistrationExpiryRow = (
  res: any
): RegistrationExpiryRow => {
  return {
    id: res.id,
    vehicle: res.vehicle,
    registrationPlate: res.registrationPlate,
    expiryDate: res.expiryDate,
  };
};
